<template>
    <!-- AccountMenu.vue -->
    <base-account-menu :email-address="emailAddress">
        <v-list-item>
            <v-list-item-icon>
                <v-icon color="secondary">mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ emailAddress }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="item in items" :key="item.title" v-bind="item.attrs" v-on="item.on">
            <v-list-item-icon>
                <v-icon :color="item.attrs.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </base-account-menu>
</template>

<script>
    // Components
    import BaseAccountMenu from '@framework/components/BaseAccountMenu'

    export default {
        name: 'AccountMenu',
        extends: BaseAccountMenu,
        components: {
            BaseAccountMenu
        },
        props: {
            /**
             * The redirect to the account portal
             */
            accountRedirectUrl: {
                type: String,
                required: true
            },
            /**
             * The url for the help and support page on the windsor site
             */
            helpUrl: {
                type: String,
                required: true
            },
            /**
             * The url for the Windsor Telecom status page
             */
            statusPageUrl: {
                type: String,
                required: true
            }
        },
        computed: {
            items () {
                const vm = this

                return [
                    {
                        attrs: {color: 'primary', href: vm.accountRedirectUrl, target: '_blank'},
                        on: {},
                        icon: 'mdi-account',
                        title: 'My Account'
                    },
                    {
                        attrs: {color: 'info', href: vm.helpUrl, target: '_blank'},
                        on: {},
                        icon: 'mdi-help-circle',
                        title: 'Help & Support'
                    },
                    {
                        attrs: {color: 'info', href: vm.statusPageUrl, target: '_blank'},
                        on: {},
                        icon: 'mdi-server',
                        title: 'Status Page'
                    },
                    {
                        attrs: {color: 'error'},
                        on: {click: vm.handleClickLogout},
                        icon: 'mdi-exit-to-app',
                        title: 'Logout'
                    }
                ]
            }
        },
        methods: {
            handleClickLogout () {
                /**
                 * @event click:logout
                 */
                this.$emit('click:logout')
            }
        }
    }
</script>
